package api.dataclasses.login

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class LoginRequest (
    @SerialName("Username") val username: String,
    @SerialName("Password") val password: String,
    @SerialName("Owner") val owner: String
)